import { CaseDiagnosis, Specimen } from "pwapi";

import { OPTIMISTICALLY_EDIT_DIAGNOSIS, SET_MACRO_CODE } from "./constants";

export const optimisticDiagnosisUpdate = (
  diagnosis: Partial<CaseDiagnosis>,
  specimen: Specimen
) => ({
  type: OPTIMISTICALLY_EDIT_DIAGNOSIS,
  payload: { specimen, diagnosis },
});

export const setInputMacroCode = (id: number, macro_code: string) => ({
  type: SET_MACRO_CODE,
  payload: { id, inputMacroCode: macro_code },
});
